import React from "react";

const Page1 = () => (
  <div>
    <a
      className="dev"
      target="_blank"
      href="https://hatimh.github.io/hospital-app-client"
      rel="noopener noreferrer"
    >
      <img src="/img/ptms.png" alt="PTMS" />
      <p>
        Patient Tracking/Management app built using Node, GraphQL and React.
      </p>
    </a>
    <a
      className="dev"
      target="_blank"
      href="https://nutrifilt.herokuapp.com/"
      rel="noopener noreferrer"
    >
      <img src="/img/NutriFilt.png" alt="NutriFilt" />
      <p>
        An app to allow users to enter their nutritional reqs. and return
        recipes. Built using Python/Django
      </p>
    </a>
    <a
      className="dev"
      target="_blank"
      href="https://snippet-man.herokuapp.com/"
      rel="noopener noreferrer"
    >
      <h1>SnippetMan</h1>
      <p>
        An app to manage private gists. Built using Ruby on Rails. Uses oauth2
        authentication.
      </p>
    </a>
    <a
      className="dev"
      target="_blank"
      href="https://hatimh.github.io/stocktickerclassic/"
      rel="noopener noreferrer"
    >
      <img src="/img/Stockticker.png" alt="Stockticker Classic" />
      <p>Stockticker board game created with js/html5 and css3</p>
    </a>
    <a
      className="dev"
      target="_blank"
      href="https://hatimh.github.io/tictactoe-react/"
      rel="noopener noreferrer"
    >
      <img src="/img/ttt-react.png" alt="Tic Tac Toe React" />
      <p>Tic Tac Toe game built using React</p>
    </a>
    <a
      className="dev"
      target="_blank"
      href="http://hatimh.github.io/JS-Feeding-Game"
      rel="noopener noreferrer"
    >
      <img src="/img/js-feed-it.png" alt="JS Feeding Game" />
      <p>"A simple java script based feed the mouth game. Don't overfeed!"</p>
    </a>
  </div>
);

const Page2 = () => (
  <div>
    <a
      className="dev"
      target="_blank"
      href="http://hatimh.github.io/cloudy-canvas"
      rel="noopener noreferrer"
    >
      <img src="/img/cloudy-canvas.png" alt="Cloudy Canvas" />
      <p>Cloudy Canvas</p>
    </a>
    <a
      className="dev"
      target="_blank"
      rel="noopener noreferrer"
      href="https://chrome.google.com/webstore/detail/selection-barcode-generat/oajnmfajchmfkofdfoccaefiininmbld/"
    >
      <img src="/img/barcode-reader.png" alt="Selection Barcode Reader" />
      <p>A chrome extension for generating bar-codes from text.</p>
    </a>
  </div>
);

class ProjectsPageDev extends React.Component {
  constructor(props) {
    super(props);
    this.pages = [<Page1 />, <Page2 />];
    this.state = { currentPageIndex: 0 };
  }

  prevPage() {
    if (this.state.currentPageIndex > 0) {
      this.setState({ currentPageIndex: this.state.currentPageIndex - 1 });
    }
  }

  nextPage() {
    if (this.state.currentPageIndex < this.pages.length - 1) {
      this.setState({ currentPageIndex: this.state.currentPageIndex + 1 });
    }
  }

  render() {
    return (
      <div className="page-content">
        <div className="navControlWrapper">
          <i
            className={`fa fa-hand-o-left navControl ${
              this.state.currentPageIndex > 0 ? "active" : ""
            }`}
            aria-hidden="true"
            onClick={() => {
              this.prevPage();
            }}
          />
          <i
            className={`fa fa-hand-o-right navControl ${
              this.state.currentPageIndex < this.pages.length - 1
                ? "active"
                : ""
            }`}
            aria-hidden="true"
            onClick={() => {
              this.nextPage();
            }}
          />
        </div>
        {this.pages[this.state.currentPageIndex]}
      </div>
    );
  }
}

export default ProjectsPageDev;
